<template>
  <div class="const">
    <div class="con_ye">
      <div class="con_width" id="print">
        <div class="cons_topname">
          <h4>《机动车 (质押) 典当合同》</h4>
          <span>编号（票号）：{{ msgVal.piaonum }}</span>
        </div>

        <div class="con_top">
          <div class="con_ne">
            <h5>
              甲方(典当行)：<u>{{ $store.state.name }}</u>
            </h5>
            <span
              >住所：<u>{{ $store.state.address }}</u></span
            >
            <span
              >法定代表人：<u>{{
                $store.state.name == "东莞市长安典当行有限责任公司" ? "蔡子森" : "卢卓君"
              }}</u></span
            >
            <span
              >联系方式：<u>{{ $store.state.tel }}</u></span
            >

            <h5>丙方(担保人)：</h5>
            <span>通讯送达住所：</span>
            <span>身份证号/营业执照号：</span>
            <span>联系方式：</span>
            <span>甲乙丙在平等自愿原则下，依据《典当管理办法》规定订立本合同。 </span>
          </div>
          <div class="con_ne">
            <h5>
              乙方(当户)：<u>{{ msgVal.name }}</u>
            </h5>
            <span
              >通讯送达住所：<u>{{ msgVal.address }}</u></span
            >
            <span
              >身份证号/营业执照号：<u>{{ msgVal.IdCard }}</u></span
            >
            <span
              >联系方式：<u>{{ msgVal.tel }}</u></span
            >
          </div>
        </div>

        <div class="cont_conte">
          <h5>第一条 当物</h5>

          <span
            >车牌号：<u>{{ msgVal.plateNumber }}</u
            >&nbsp;&nbsp;&nbsp;
          </span>

          <span>
            公里数:<u>{{ msgVal.mileage }}</u
            >&nbsp;&nbsp;&nbsp;</span
          >
          <span>
            车辆型号：<u>{{ msgVal.brand }}</u
            >&nbsp;&nbsp;&nbsp;</span
          >

          <span>
            车辆识别代号：<u>{{ msgVal.vin }}</u
            >&nbsp;&nbsp;&nbsp;</span
          >
          <span>
            发动机号码：<u>{{ msgVal.engineNumber }}</u
            >&nbsp;&nbsp;&nbsp;</span
          >

          <h5>第二条 当金、当期、典当综合费用、典当利息</h5>

          <p>
            2.1 典当双方按《估价协议》协议车辆可质押典当借款金额
            <u>{{ msgVal.sum }}</u> 元。
          </p>
          <p>2.2 典当用途：<u>当金用途：短期周转，不得非法用途。</u></p>
          <p>
            2.3 典当期限为<u> {{ msgVal.det }} </u>日，即自<u>
              {{ countDate(msgVal.startDate, "YYYY") }}</u
            >
            年<u>{{ countDate(msgVal.startDate, "MM") }}</u
            >月 <u>{{ countDate(msgVal.startDate, "DD") }} </u> 日起至<u>
              {{ countDate(msgVal.DateClosed, "YYYY") }} </u
            >年<u> {{ countDate(msgVal.DateClosed, "MM") }}</u
            >月<u> {{ countDate(msgVal.DateClosed, "DD") }} </u>日止。
          </p>
          <p>
            2.4 每期典当综合费：按月综合费率<u> 4.2 </u>%计算（30天为一个月）即<u>
              {{ Math.round(msgVal.sum * 0.042) }} </u
            >元/期。
          </p>
          <p>
            2.5 每期典当利息：按月费率 <u> 0.28 </u>%计算（30天为一个月）即<u>
              {{ Math.round(msgVal.sum * 0.0028) }}</u
            >元/期。
          </p>
          <p>2.6符合约定条件，甲同意减免部分典当综合费用、典当利息：</p>
          <p>
            2.6.1 乙先按典当费率<u> {{ msgVal.priceZ }}</u
            >%（即<u> {{ Math.round(msgVal.sum * (msgVal.priceZ / 100)) }} </u
            >元）支付一部分典当综合费，乙在典当期限内赎当或双方在典当到期前同意续当的，剩余未付的部分综合费<u>
              {{ Math.round(msgVal.sum * ((4.2 - msgVal.priceZ) / 100)) }}</u
            >元甲方典当行同意减免；当期内典当利息<u>
              {{ Math.round(msgVal.sum * 0.0028) }}</u
            >元（后收）在续当或赎当时支付。。
          </p>
          <p>
            2.6.2乙逾期续当按月综合费率 4.2
            %、月典当利率按同期LPR折算计收《续当凭证》当期综合费和典当利息；乙逾期赎当的，甲不减免上述条款乙未付的综合费和利息，乙结清逾期拖欠的综合费用、利息后才能赎当，逾期不足5天赎当按5天计费。
          </p>
          <p>2.7 停车费 典当期间包含逾期、绝当后的时间，停车费按<u> 15 </u>元/天收费。</p>

          <h5>第三条 当金发放、归还</h5>

          <p>3.1 当金发放到乙指定收款账户，或收取现金；</p>
          <p>
            开户行：<span
              v-html="
                '\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0'
              "
            ></span>
            户名：
            <span
              v-html="
                '\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0'
              "
            ></span>
            账号：
          </p>

          <p>3.2 3.2 当金归还，乙须按时足额支付综合费用及利息；甲方指定以下账户：</p>
          <p>
            开户行：
            <span
              v-html="
                '\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0'
              "
            ></span>
            户名：
            <span
              v-html="
                '\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0'
              "
            ></span>
            账号：
          </p>

          <h5>第四条 续当</h5>

          <p>
            4.1乙在当票或续当凭证期限届满前办理续当，甲须先对车辆重新估价，若估价低于在当金额，甲有权要求乙归还差额本金或清偿任意金额本金；乙方不接受，须到期前归还全部当金赎回当物。逾期续当，甲按《典当管理办法》最高费率标准计费。
          </p>
          <p>
            4.2
            典当到期不能赎回，经双方同意续当的，续当时须归还部分本金（如没明确书面约定分期方式，最低归还六分之一的本金）。
          </p>

          <h5>第五条 赎当</h5>

          <p>
            5.1乙在当期内赎当的，甲方已收取的综合费用不予退还；乙按顺序付清综合费用、典当利息、当金及其他相关费用；当期届满后5天内赎当是逾期赎当，逾期不足5天赎当按5天计费。
          </p>
          <p>
            5.2乙逾期赎当，除甲书面同意外，甲分别按4.2%月综合费率、按同期PLR折算收取从建立典当之日起到赎当之日止的典当综合费用和典当利息。
          </p>
          <p>
            5.3在绝当起至当物被处置前乙提出赎当的，乙应结清拖欠的综合费用、典当利息、违约金、甲垫付的维权费用以及甲为实现债权已付的费用。
          </p>
          <p>5.4乙完成赎当，甲出具结清证明协助乙办理解除当物质押登记手续。</p>
          <p>
            5.5赎当取车时间：营业时间的上午9点到下午5点，甲方足额收到全部典当金额（银行实时到账为准）后质押汽车才放行出库交还当户。
          </p>

          <h5>第六条 绝当</h5>

          <p>6.1乙在当期限届满逾期5日既不续当又不赎当的，为绝当。</p>
          <p>
            6.2从绝当起，除按《典当管理办法》处置外，甲将委托律师事务所催收诉讼维权，因此产生的诉讼费用、律师代理费（参照广东省律师收费标准）全部由违约方承担；乙为及时清偿甲方典当借款，甲认可乙另行授权同意甲方或委托第三方对外转让担保物所有权或转让本合同全部债权予以清偿典当本金、典当综合费用、利息、以及实现债权的费用。
          </p>
          <p>6.3绝当物处置所得款不足清偿全部债务，乙在绝当日起无条件向甲清偿剩余债务。</p>

          <h5>第七条 质押车辆的保险</h5>

          <p>
            7.1.质押典当期间，乙应当为质押汽车购买商业保险（车损险、划痕险、盗抢险、玻璃破碎险、交强险）、甲发现典当车辆的保险期没有覆盖典当期间的，有权提前解除典当合同要求乙立即赎回车辆或不再续当。
          </p>

          <h5>第八条 逾期利息、违约金</h5>

          <p>
            8.1乙未按期支付典当综合费用、归还本金，甲有权按《典当管理办法》规定的不超过4.2%月费率为限要求乙支付从逾期之日起的逾期利息、违约金。
          </p>

          <h5>第九条 乙声明及保证</h5>

          <p>
            9.1乙保证在典当质押存续期间享有当物的所有物权；在签订合同时以及履行合同期间，乙在当物上没有设立或允许或不得设立任何担保权利；因乙提供的质押物存在负权利例如已设立了质押/抵押登记，导致车辆无法办理质押登记到甲名下，本典当合同无法履行的过错责任由乙方承担。乙方提供给甲方的与质押有关的所有材料真实、合法、准确、完整，且保证履行配合办理质押登记手续；
          </p>
          <p>
            9.2乙保证当物未被查封、扣押、监管或被采取其他强制性措施。若当物出现上述情形，乙方应及时通知甲方并清偿当金；
          </p>

          <h5>第十条 典当质押担保、担保人连带担保</h5>

          <p>10.1乙自愿以其所有的车辆交付甲作为质押担保并办理质押手续，保证合同履行。</p>
          <p>10.2为保证合同履行，担保人丙方愿意为乙的当金归还义务承担连带担保责任。</p>
          <p>
            10.3担保的范围和期限：本合同项下的当金、典当综合费用、典当利息，逾期利息；为实现债权产生的费用。担保期间为绝当之日起6个月。
          </p>

          <h5>第十一条 违约责任</h5>

          <p>
            11.1甲乙丙应履行各自义务，任何一方不履行或不完全履行本合同约定义务的，应当承担违约责任。
          </p>
          <p>
            11.2当票或续当凭证期限届满，乙5天内既不续当又不赎当的为绝当，乙方构成违约，乙应当结清当金、综合费用、典当利息及甲实现债权的费用（因乙方违约产生的诉讼律师代理费，或发函催告等合理费用）。此外，乙方应当按当金的20%支付合同违约金。
          </p>
          <p>
            11.3当物与乙声明条款不一致，甲有权单方解除合同提前要求乙一次性归还当金赎回当物。因乙方提供的质押汽车存在负权利质押/抵押登记，导致甲方无法办理质押登记，双方无法履行典当合同的过错责任由乙方承担。
          </p>

          <h5>第十二条 争议的解决</h5>

          <p>
            本合同在履行过程中发生争议的，甲乙双方应协商解决；协商不成的，按任何一方均可向甲方所在地人民法院提起诉讼。
          </p>

          <h5>第十三条 重要的补充约定</h5>
          <p>
            13.1
            补充约定：1，典当到期，《续当凭证》作为本合同的延期补充协议；2，《当票》背后的典当须知作为本合同的补充约定：其中《当票》背面典当须知第5条以及《典当管理办法》第四十一条规定典当行在当期内不得出租、质押、抵押和使用当物。质押当物在典当期内或者续当期内发生遗失或者损毁的，典当行应当按照估价金额进行赔偿。遇有不可抗力导致质押当物损毁的，典当行不承担赔偿责任。
          </p>
          <p>13.2</p>
          <p>
            13.3
            双方签字、加盖印章后合同生效。合同未尽事宜，双方可补充协议，典当告知书、当票、续当凭证是本合同的重要组成部分，与本合同具有同等法律效力。
          </p>
          <p>13.4 本合同一式 2 份，甲、乙各执 1 份。</p>

          <h4><center>忠 告</center></h4>
          <p>
            典当是短期、高费息借贷，逾期绝当将会丧失当物处置权的后果。在典当借贷前，忠告当户清晰理解典当期限、费息约定，当金不得用于房地产市场违规融资等违规用途；如果不能接受或承担典当违约的责任，请您停止办理典当。
          </p>
          <p>请甲阅读抄写：</p>
          <p>
            本人
            <u>{{ msgVal.name }}</u>
            清楚上述典当期限、费率、续当还本的约定，因逾期续或赎当导致绝当，本人自愿承担违约责任。
          </p>
          <span style="margin: 10px 0"> </span>
        </div>
        <div class="con_cons">
          <div class="con_left">
            <div class="con_lefts">
              <p>甲方（抵押权人/典当行）：</p>

              <p>代理人（签名）：</p>
            </div>
          </div>
          <div class="con_right">
            <p>乙方（质押人/当户）：</p>

            <p>法定代表人（签名）：</p>

            <p>丙方（担保人签字盖章）：</p>
          </div>
        </div>
        <p style="font-size: 12px">
          合同签订日期：{{
            countDate(msgVal.startDate, "YYYY") +
            "年" +
            countDate(msgVal.startDate, "MM") +
            "月" +
            countDate(msgVal.startDate, "DD") +
            "日"
          }}
        </p>
        <p style="font-size: 12px">合同签订地点：东莞市长安镇</p>
      </div>
      <div class="bTn">
        <button v-print="'#print'">打印合同</button>
        <!-- <el-button type="primary">打 印 合 同</el-button> -->
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";

export default {
  name: "Contract",
  props: ["msgVal"],
  data() {
    return {
      ACCESS_TOKEN: "", //ACCESS_TOKEN,
    };
  },
  // watch(){

  // },
  methods: {
    //日期转换
    countDate(event, type) {
      return dayjs(event).format(`${type}`);
    },
  },
  created() {},
  mounted() {},
};
</script>

<style scoped>
.const {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.con_ye {
  width: 100%;
  background-color: #ffffff;
}
.con_width {
  width: 90%;
  margin: 0 auto;
}
.con_width span {
  font-size: 12px;
}
.cont_conte p {
  font-size: 12px;
}
.cons_topname {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 5px 0;
}
.con_top {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.con_ne {
  display: flex;
  flex-direction: column;
  margin: 10px 0;
}
.con_ne span {
  margin: 10px 0;
}
.con_cons {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin: 5px 0;
  font-size: 12px;
}
.con_left {
  display: flex;
  flex-direction: column;
  margin: 10px 0;
}
.con_lefts {
  width: 150px;
  height: 150px;
  /* background: url("../assets/411212.png"); */
}
.con_right {
  display: flex;
  flex-direction: column;
  margin: 10px 0;
}
.bTn {
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
</style>
